(() => {
  // NZS-CDR-SHAKE-0821 r17 - ponytail: the shake is now PURE CSS (nzs-base.css,
  // #nzsCdrCheckout.cc-checkout-shimmer infinite `nzs-cdr-wiggle`), replicating Macro
  // Mike's Corner-cart mechanism. No JS clock = it can't be skipped by a hidden tab or
  // the drawer's MutationObserver. This file now only marks the button and injects the
  // shimmer-shine span the CSS hover/focus sweep needs. The static single-drawer markup
  // means a load-time query is enough (see prior r13 note).
  const start = () => {
    const button = document.getElementById('nzsCdrCheckout');
    if (!button) return;
    button.classList.add('cc-checkout-shimmer');
    if (!button.querySelector(':scope > .cc-checkout-shimmer__shine')) {
      const shine = document.createElement('span');
      shine.className = 'cc-checkout-shimmer__shine';
      shine.setAttribute('aria-hidden', 'true');
      button.prepend(shine);
    }
  };
  document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', start, { once: true })
    : start();
})();
